<template>
    <div>
      <BaseFrame
        :showCtrls="false"
      >
      <div slot="content">
        <loadingSpan v-if='loading' fix>加载中...</loadingSpan>
      <div class="content">
        <lk-card class="mb16">
          <div class="btnArea" v-if="handlePermission('roleMutexAdd')">
          <lk-button type="primary" @click="toCreateRole">+新建互斥角色</lk-button>
          </div>
          <div class="tableArea">
            <lk-table :columns='columns' :data='tableData' border ></lk-table>
          </div>
          <lk-Page
            class="pages"
            show-sizer
            show-elevator
            show-total
            :page-size="size"
            v-if="!disablePage"
            @on-page-size-change='handlePageSize'
            @on-change='handlePage'
            :total = 'count'
            :page-size-opts='[20,30,50,100]'
            :current="page"
          ></lk-Page>
        </lk-card>
      </div>
      </div>
      </BaseFrame>
      <lk-modal
            v-model="addRole"
            :title="addRoleTitle"
            :width="340"
            :mask-closable='false'
            @on-cancel="handleCancelSelection"
            >
            <lk-form :label-width='80'
            label-position="left"
            :model='roleData'
            :rules="roleDataValidate"
            ref="form">
            <lk-form-item label='角色类型:' prop='type'>
              <lk-select v-model="roleData.type" style="width:200px" filterable @on-change='roleTypeChange'>
                <lk-option v-for="(item,index) in roleTypeList" :key="index" :value='item.id'>{{item.name}}</lk-option>
              </lk-select>
            </lk-form-item>
            <lk-form-item label='角色1:' prop='roleId'>
              <lk-select v-model="roleData.roleId" style="width:200px" filterable @on-change='role1Change'>
                        <lk-option v-for="(item,index) in roleList" :key="index" :value='item.id'>{{item.name}}</lk-option>
                    </lk-select>
            </lk-form-item>
            <lk-form-item label='角色2:' prop='repelRoleId'>
              <lk-select v-model="roleData.repelRoleId" style="width:200px" filterable @on-change='role2Change'>
                        <lk-option v-for="(item,index) in roleList" :key="index" :value='item.id'>{{item.name}}</lk-option>
                    </lk-select>
            </lk-form-item>
            </lk-form>
            <div class="modalFooter" slot="footer">
                <span style="font-size: 1px; color: red; display: inline-block; margin-right: 15px;">所选角色1、2将不能同时配置到同一账号下</span><lk-button type='primary' @click='toSaveRole'>保存</lk-button>
            </div>
        </lk-modal>
    </div>
  </template>
<script>
import utils from '@/libs/utils';
import tools from '@/services/tools';
import loadingSpan from '@/components/LoadingSpan.vue';
import system from '../../services/system';
import BaseFrame from '../../components/frame/BaseFrame.vue';
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'roleMutex',
  components: {
    loadingSpan,
    BaseFrame,
  },
  mixins: [queryMixins],
  computed: {},
  data() {
    return {
      roleDataValidate: {
        type: [
          {
            required: true,
            message: '请选择角色类型',
            trigger: 'change',
            type: 'number',
          },
        ],
        roleId: [
          {
            required: true,
            message: '请选择角色1',
            trigger: 'change',
            type: 'number',
          },
        ],
        repelRoleId: [
          {
            required: true,
            message: '请选择角色2',
            trigger: 'change',
            type: 'number',
          },
        ],
      },
      roleList: [],
      roleTypeList: [{ id: 1, name: '总部角色' }, { id: 2, name: '门店角色' }],
      roleData: {
        type: '',
        roleId: -1,
        roleName: '',
        repelRoleId: -1,
        repelRoleName: '',
      },
      addRole: false,
      addRoleTitle: '新建互斥角色',
      size: 20,
      page: 1,
      count: 0,
      loading: false,
      tableData: [],
      columns: [
        {
          title: '序号',
          minWidth: 20,
          type: 'index',
          align: 'center',
        },
        {
          title: '角色类型',
          key: 'typeName',
          minWidth: 116,
          align: 'center',
        },
        {
          title: '角色1',
          key: 'roleName',
          minWidth: 116,
          align: 'center',
        },
        {
          title: '角色2',
          key: 'repelRoleName',
          minWidth: 116,
          align: 'center',
        },
        {
          title: '操作人',
          key: 'modifiedUserName',
          minWidth: 116,
          align: 'center',
        },
        {
          title: '最后修改时间',
          key: 'modifiedTime',
          minWidth: 116,
          align: 'center',
          render: (h, { row }) => h('span', utils.formatTime(row.modifiedTime)),
        },
        {
          title: '状态',
          key: 'status',
          align: 'center',
          width: 110,
          render: (h, { row }) => (this.handlePermission('roleMutexEdit') ? h('lk-switch', {
            props: {
              value: row.status === 1,
              size: 'large',
            },
            on: {
              'on-change': (value) => {
                const Message = value ? '已启用' : '已停用';
                this.changeRoleStatus(row, Message);
              },
            },
          }, [
            h('span', {
              slot: 'open',
            }, '启用'),
            h('span', {
              slot: 'close',
            }, '停用'),
          ]) : h('span', row.status === 1 ? '已启用' : '已停用')),
        },
        {
          title: '操作',
          minWidth: 26,
          align: 'center',
          render: (h, { row }) => h('div', [
            this.handlePermission('roleMutexEdit') && h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
              },
              on: {
                click: () => {
                  this.editRole(row);
                },
              },
            }, '修改'),
            this.handlePermission('roleMutexDelete') && h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
              },
              on: {
                click: () => {
                  this.deleteRole(row.id);
                },
              },
            }, '删除'),
          ]),
        },
      ],
    };
  },
  methods: {
    // 修改角色类型
    roleTypeChange(value) {
      this.roleList = []; // 清空数据
      this.roleData.roleId = '';
      this.roleData.repelRoleId = '';
      if (value) {
        this.getTypeList(value);
      }
    },
    getTypeList(type) {
      this.loading = true;
      return new Promise((resolve) => {
        const tempP = { page: 1, size: 1000, type };
        system.storeListEnable(tempP).then((res) => {
          if (res.data.status === 200) {
            this.roleList = res.data.data.list;
          } else {
            this.$Message.error(res.data.error);
          }
          this.loading = false;
          resolve();
        }).catch((err) => {
          this.loading = false;
          utils.handleError(err);
        });
      });
    },
    role1Change(value) {
      if (this.roleList.length > 0) {
        this.roleData.roleName = this.roleList.filter(item => item.id == value)[0].name;
      }
    },
    role2Change(value) {
      if (this.roleList.length > 0) {
        this.roleData.repelRoleName = this.roleList.filter(item => item.id == value)[0].name;
      }
    },
    editRole(row) {
      this.$refs.form.resetFields();
      this.roleList = [];
      this.addRoleTitle = '修改互斥角色';
      this.roleData = null;
      const tempData = {
        type: row.type,
        roleId: row.roleId,
        roleName: row.roleName,
        repelRoleId: row.repelRoleId,
        repelRoleName: row.repelRoleName,
        id: row.id,
      };
      this.addRole = true;
      this.getTypeList(row.type).then(() => {
        this.roleData = tempData;
      });
    },
    deleteRole(id) {
      this.$Modal.confirm({
        title: '是否确认删除？',
        cancelText: '取消',
        okText: '确认',
        onOk: () => {
          tools.deleteRoleMutex({ id }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('删除成功');
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            utils.handleError(err);
          });
        },
      });
    },
    changeRoleStatus(row, message) {
      const tempRequest = row.status == 1 ? tools.roleClose : tools.roleOpen;
      tempRequest({ id: row.id }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success(message);
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      });
    },
    toCreateRole() {
      this.$refs.form.resetFields();
      this.roleList = [];
      this.addRoleTitle = '新建互斥角色';
      this.roleData.roleId = '';
      this.roleData.repelRoleId = '';
      this.roleData.type = '';
      this.roleData.roleName = '';
      this.roleData.repelRoleName = '';
      delete this.roleData.id;
      this.addRole = true;
    },
    toSaveRole() {
      this.$refs.form.validate((goodsFormValid) => {
        if (!goodsFormValid) {
          return;
        }
        if (this.roleData.roleId == this.roleData.repelRoleId) {
          this.$Message.error('角色1和角色2不能相同');
          return;
        }
        this.loading = true;
        const isAdd = this.addRoleTitle === '新建互斥角色';
        const tempRequest = isAdd ? tools.addRoleMutex : tools.editRoleMutex;
        tempRequest(this.roleData).then((res) => {
          if (res.data.status === 200) {
            this.addRole = false;
            this.$Message.success(isAdd ? '添加成功' : '修改成功');
            this.getData();
          } else {
            this.$Message.error(res.data.error);
          }
          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          utils.handleError(err);
        });
      });
    },
    handleCancelSelection() {
      this.addRole = false;
      this.$refs.form.resetFields();
      this.roleList = [];
    },
    handlePageSize(size) {
      this.size = size;
      this.getData();
    },
    handlePage(page) {
      this.page = page;
      this.getData();
    },
    getData() {
      this.loading = true;
      const historyParams = { page: this.page, size: this.size };
      tools.roleMutexList(historyParams).then((res) => {
        if (res.data.status === 200) {
          this.loading = false;
          this.tableData = res.data.data.list;
          this.count = res.data.data.count;
        } else {
          this.loading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
    .content {
      margin: 0px !important;
      padding: 0px !important;
    }
    .btnArea {
      margin-bottom: 10px;
    }

    .pages{
    margin-top: 16px;
    text-align: right
  }
</style>
